// Token of this browser for "Lembrar este dispositivo por 30 dias". Firestore keeps only its hash in
// users/{uid}/trustedDevices/{id}; the Cloud Function verifyTrustedDevice compares both at sign-in.
export interface TrustedDeviceToken {
  uid: string,
  deviceId: string,
  token: string
}

const STORAGE_KEY = 'trustedDevice';

export function readTrustedDevice(uid: string): TrustedDeviceToken | null {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as TrustedDeviceToken | null;
    return saved?.uid == uid && saved.deviceId && saved.token ? saved : null;
  } catch {
    return null;
  }
}

export function saveTrustedDevice(device: TrustedDeviceToken): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(device));
  } catch { }
}

export function forgetTrustedDevice(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { }
}

// Id of the trusted device of this browser, to mark it in Settings
export function currentTrustedDeviceId(uid: string): string | null {
  return readTrustedDevice(uid)?.deviceId ?? null;
}

// Name shown in Settings, e.g. "Chrome · Windows"
export function deviceLabel(userAgent: string = navigator.userAgent): string {
  const browser =
    /Edg\//.test(userAgent) ? 'Edge' :
    /OPR\//.test(userAgent) ? 'Opera' :
    /Firefox\//.test(userAgent) ? 'Firefox' :
    /Chrome\//.test(userAgent) ? 'Chrome' :
    /Safari\//.test(userAgent) ? 'Safari' : 'Navegador';
  const system =
    /Windows/.test(userAgent) ? 'Windows' :
    /Android/.test(userAgent) ? 'Android' :
    /iPhone|iPad/.test(userAgent) ? 'iOS' :
    /Mac OS X/.test(userAgent) ? 'macOS' :
    /Linux/.test(userAgent) ? 'Linux' : '';
  return system ? `${browser} · ${system}` : browser;
}
